import type { Channel } from "../../lib/profile.ts";

export function LuggageTag({ kind, label, line, href }: Channel) {
  return (
    <a className="home-tag" href={href} target="_blank" rel="noopener">
      <span className="home-tag-end" aria-hidden="true" />
      <span className="home-tag-body">
        <span className="home-tag-kind">{kind}</span>
        <span className="home-tag-label">{label}</span>
        <span className="home-tag-line">{line}</span>
      </span>
    </a>
  );
}
